class ComplementaryComponent extends SlideshowComponent {
    constructor() {
        super();
        // custom complementary related functions here
    }
}

customElements.define('complementary-component', ComplementaryComponent);